(() => {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Animate real Shopify page sections only. Do not attach reveal state to footer.
  const revealSelector = 'main#MainContent > .shopify-section';
  const readyClass = 'bruttus-scroll-ready';
  const itemClass = 'bruttus-scroll-item';
  const visibleClass = 'bruttus-scroll-visible';
  const sectionClass = 'bruttus-scroll-section';
  const sectionVisibleClass = 'bruttus-scroll-section-visible';

  let observer;

  const isElementUsable = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    if (el.matches('[hidden], [aria-hidden="true"], script, style, noscript')) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const reveal = (el) => {
    el.classList.add(visibleClass, sectionVisibleClass);
    if (observer) observer.unobserve(el);
  };

  const shouldReveal = (entry) => {
    if (!entry.isIntersecting) return false;
    if (entry.intersectionRatio >= 0.2) return true;

    // Tall lazy-image sections can never reach a 20% ratio on small screens.
    // Reveal them when their top reaches the active scroll area instead.
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    const rect = entry.boundingClientRect;
    return rect.height > viewportH && rect.top <= viewportH * 0.8;
  };

  const getPreparedNodes = () => Array.from(document.querySelectorAll(revealSelector)).filter(isElementUsable);

  const prepare = () => {
    const nodes = getPreparedNodes();

    nodes.forEach((el) => {
      el.classList.add(itemClass, sectionClass);
    });

    document.documentElement.classList.add(readyClass);

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(reveal);
      return;
    }

    if (observer) observer.disconnect();

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (shouldReveal(entry)) reveal(entry.target);
      });
    }, {
      threshold: [0, 0.2],
      rootMargin: '0px 0px -8% 0px'
    });

    nodes.forEach((el) => {
      if (el.classList.contains(visibleClass)) return;
      observer.observe(el);
    });
  };

  const prepareNewSectionsOnly = () => {
    const nodes = getPreparedNodes().filter((el) => !el.classList.contains(itemClass));

    nodes.forEach((el) => {
      el.classList.add(itemClass, sectionClass);
      if (reduce || !('IntersectionObserver' in window)) {
        reveal(el);
      } else if (observer) {
        observer.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepare, { once: true });
  } else {
    prepare();
  }

  // Some Shopify/image sections only get real height after lazy media settles.
  window.addEventListener('load', () => {
    window.requestAnimationFrame(prepareNewSectionsOnly);
  }, { once: true });

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(prepareNewSectionsOnly);
  });
})();
